export default "__VITE_ASSET__DHg50pCc__"